if (!customElements.get('marquee-text')) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
    }

    animationLoop() {
      if (this.enablePause && this.stopped) {
        return window.requestAnimationFrame(() => this.animationLoop());
      }

      let rightSideOfFirstItem = this.currentLeft + this.firstListItemWidth;

      if (rightSideOfFirstItem <= this.containerLeft) {
        this.currentLeft = -this.speed;
        this.appendChild(this.firstListItem);

        this.firstListItem = this.querySelector('*:first-child');
        this.firstListItemWidth = this.firstListItem
          ? this.firstListItem.getBoundingClientRect().width
          : 0;
      }

      this.style.transform = `translate3d(${this.currentLeft}px, 0, 0)`;
      this.currentLeft -= this.speed;

      window.requestAnimationFrame(() => this.animationLoop());
    }

    connectedCallback() {
      this.containerLeft = this.parentElement.getBoundingClientRect().left;
      this.currentLeft = 0;
      this.stopped = false;
      this.speed = Number(this.dataset.speed) || 1;
      this.enablePause = this.hasAttribute('data-pause-on-hover');

      this.addEventListener('mouseenter', () => (this.stopped = true));
      this.addEventListener('mouseleave', () => (this.stopped = false));

      this.firstListItem = this.querySelector('*:first-child');
      this.firstListItemWidth = this.firstListItem
        ? this.firstListItem.getBoundingClientRect().width
        : 0;

      this.animationLoop();
    }
  }

  customElements.define('marquee-text', MarqueeText);
}
